import {Component, Inject, OnInit} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ToastrService} from "ngx-toastr";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UserService} from "../../../services/user.service";
import { Router} from '@angular/router';
import {CasinoBetsService} from "../../../services/casino/casino-bets.service";

@Component({
  selector: 'app-casino-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css']
})
export class CasinoTennPattiOpenPopupComponent implements OnInit {
  passwordForm: any;
  errorMsg: any;
  submitted = false;
  details: any = {};
  winner: any = '';
  winners: any = [];
  cards: any = '';
  pairplus: any = '';
  other_winners: any = '';
  casino_bets: any = [];
    filter_bets: any = [];
    totalbets: number = 0;
    totalAmount: number = 0;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,private casinoBetsService:CasinoBetsService,private router: Router, public dialogRef: MatDialogRef<any>, private fb: FormBuilder, private userService: UserService, private toasterService: ToastrService) {

  }


  ngOnInit(): void {
    this.dialogRef.updateSize('100%',);
    if(!this.data.acc_state){
      this.getTeenPattiDetails();
      }else{
        this.getCasinoResultonMarketId();
      }
      this.getCasinoBetsByMarketID();
  }

  getCasinoResultonMarketId(){
    this.casinoBetsService.getCasinoResultonMarketId(this.data.mid).subscribe((res:any)=>{
      console.log('res',res);
      if(res.length>0){
      const renamedObject = {
        ...res[0],          // Copy all existing properties
        desc: res[0].description, // Rename description to desc
        cards: res[0].result // Rename result to cards
      };
      console.log("renamedObject",renamedObject);
      this.getResults(renamedObject)
    }
    })
  }

  getTeenPattiDetails() {
    this.casinoBetsService.getTeenPattiDetails(this.data.mid).subscribe((res: any) => {
      if(res.success){
        this.details = res.data;
        console.log('result',this.details);
        this.getResults(this.details[0]);
      }
    });
    this.getCasinoBetsByMarketID();
  }

  private getResults(data:any){
    this.winner = (data.sid.split('|')[0]).replace(/,/g, ' ');
    this.winners = data.sid.split('|')[0].split(",").map(Number);
    this.other_winners = this.getOtherWinners(data.cards);
    this.cards = this.divideCardsIntoArrays(data.cards);

    this.pairplus = this.getpairPlus(data.cards);
  }

  private getOtherWinners(cards:any){
    let desc_aaa = cards.split(",");
    let arrayOfArrays:any = Array.from({ length: 9 }, () => []);
    let results:any = []; // Array to store results in the format index+1:pattern
    
    // Distribute cards into arrays (example logic)
    desc_aaa.forEach((card:any, index:any) => {
        arrayOfArrays[index % 9].push(card); // Assign cards to one of 9 arrays cyclically
    });
    
    // Helper function to extract rank and suit
    function parseCard(card:any) {
        const rank = card.slice(0, -2); // Everything except the last two characters
        const suit = card.slice(-2);   // Last two characters
        return { rank, suit };
    }
    
    // Check for flush
    function isFlush(cards:any) {
        const suits = cards.map((card:any) => parseCard(card).suit);
        return suits.every((suit:any) => suit === suits[0]);
    }
    
    // Check for straight
    function isStraight(cards:any) {
        const ranks = cards
            .map((card:any) => parseCard(card).rank)
            .map((rank:any) => {
                if (rank === "A") return 1;  // Treat Ace as 1
                if (rank === "J") return 11;
                if (rank === "Q") return 12;
                if (rank === "K") return 13;
                return parseInt(rank, 10);  // Convert numeric ranks
            })
            .sort((a:any, b:any) => a - b);
        
        for (let i = 1; i < ranks.length; i++) {
            if (ranks[i] !== ranks[i - 1] + 1) return false;
        }
        return true;
    }
    
    // Check for trio
    function isTrio(cards:any) {
        const rankCounts:any = {};
        cards.forEach((card:any) => {
            const rank = parseCard(card).rank;
            rankCounts[rank] = (rankCounts[rank] || 0) + 1;
        });
        return Object.values(rankCounts).includes(3);
    }
    
    // Check for flush straight
    function isFlushStraight(cards:any) {
        return isFlush(cards) && isStraight(cards);
    }
    
    // Evaluate each inner array and store results
    arrayOfArrays.forEach((array:any, index:any) => {
        if (isFlush(array)) results.push(`${index + 1}:flush`);
        if (isStraight(array)) results.push(`${index + 1}:straight`);
        if (isTrio(array)) results.push(`${index + 1}:trio`);
        if (isFlushStraight(array)) results.push(`${index + 1}:flush straight`);
    });
    
    // Output results
    console.log("Patterns Detected:");
    console.log(results);
    return results;
  }

  convertToNumber(num:any){
    return Number(num);
  }

  private getpairPlus(cards: string): string {
    let teen8 = '';
    if (cards.length > 0) {
      let desc_aaa = cards.split(",");
      let count = 0;
      let arrayOfArrays: string[][] = Array.from({ length: 9 }, () => []);
  
      desc_aaa.forEach((item) => {
        let toAdd: string | undefined;
        if (item.length === 3) {
          toAdd = item.charAt(0);
        } else if (item.length === 4) {
          toAdd = item.substring(0, 2);
        }
        if (toAdd !== undefined) {
          arrayOfArrays[count].push(toAdd);
          count++;
          if (count === 9) {
            count = 0;
          }
        }
      });
  
      const hasDuplicates = (array: any[]): boolean => {
        return new Set(array).size !== array.length;
      };
  
      let indicesWithDuplicates: string[] = [];
      arrayOfArrays.forEach((innerArray, index) => {
        if (hasDuplicates(innerArray)) {
          indicesWithDuplicates.push(`Pair plus ${index + 1}`);
        }
      });
      teen8 = indicesWithDuplicates.join("|");
      console.log(teen8);
    }
    return teen8;
  }
  
  
  private divideCardsIntoArrays(inputString: string): any[] {
    let elements = this.rearrangeCards(inputString);
    elements.join(",")
    let groupedArray = [];
    for (let i = 0; i < elements.length; i += 3) {
        let group = elements.slice(i, i + 3);
        groupedArray.push(group);
    }
    return groupedArray;
  }

  
  private rearrangeCards(cards:any){
    let cardArray = cards.split(',');

    // Initialize a result array to store the selected cards
    let selectedCards = [];

    // Total number of cards
    let totalCards = cardArray.length;

    // Loop through the card array, selecting every i + n * 9 (where n is the step)
    for (let i = 0; i < 9; i++) {
      for (let j = i; j < totalCards; j += 9) {
        selectedCards.push(cardArray[j]);
      }
    }

    return selectedCards; 
  }

  private divideIntoArrays(inputString:string) {
    const gameArray = inputString.split(',');
    const array1:any = [];
    const array2:any = [];
  
    gameArray.forEach((game, index) => {
      if (index % 2 === 0) {
        array1.push(game);
      } else {
        array2.push(game);
      }
    });
  
    return [array1, array2];
  }

   getCasinoBetsByMarketID() {
        this.casinoBetsService.getCasinoBetsByOnlyMarketId(this.data.mid).subscribe((res: any) => {
            console.log('filter_bets data', res);
            this.casino_bets = res;
            this.filter_bets = this.casino_bets;
            this.totalbets = this.casino_bets.length;
            this.totalAmount = this.casino_bets.reduce((sum: any, entry: any) => sum + (entry.profit_loss || 0), 0);
        });
    }

    filterBetsByType(event: any) {
        const filterType = (event.target as HTMLInputElement).value;
        console.log('filterType', filterType);
        if (filterType === 'all') {
            this.filter_bets = this.casino_bets;
        } else if (filterType === 'deleted') {
            this.filter_bets = this.casino_bets.filter((bet: any) => bet.from === "deleted");
        } else if (filterType === 'Back') {
            this.filter_bets = this.casino_bets.filter((bet: any) => bet.type === "Back");
        }
        if (filterType === 'Lay') {
            this.filter_bets = this.casino_bets.filter((bet: any) => bet.type === "Lay");
        }
        this.totalbets = this.filter_bets.length;
        this.totalAmount = this.filter_bets.reduce((sum: any, entry: any) => sum + (entry.profit_loss || 0), 0);
    }

  closeDialog() {
    this.dialogRef.close();
  }

  dismiss() {
    this.dialogRef.close();
  }

}
